import styled from "styled-components";
import i18n from "../../i18n";
import { useState, useTransition } from "react";

export default function LocaleSwitcher({ id }: { id?: string }) {
  const [pending, startTransition] = useTransition();
  const [lng, setLng] = useState<"ar" | "en">((i18n.language as "ar" | "en") || "en");

  const toggle = () => {
    const next = lng === "ar" ? "en" : "ar";
    startTransition(() => {
      i18n.changeLanguage(next).then(() => {
        localStorage.setItem("lang", next);
        setLng(next);
        // dir is handled inside AppThemeProvider via i18n languageChanged listener
      });
    });
  };

  return (
    <Btn
      id={id}
      onClick={(e) => { e.stopPropagation(); toggle(); }}
      disabled={pending}
      data-pending={pending ? "" : undefined}
      aria-busy={pending}
      aria-label={lng === "ar" ? "Switch to English" : "التبديل إلى العربية"}
      title={lng === "ar" ? "English" : "العربية"}
    >
      <span className="label">{lng === "ar" ? "EN" : "ع"}</span>
      <span className="spinner" aria-hidden />
    </Btn>
  );
}

const Btn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  height: 36px;
  padding-inline: 10px;
  border-radius: 10px;
  border: 1px solid var(--border);
  background: var(--surface);
  color: var(--text);
  font-weight: 700;
  cursor: pointer;
  position: relative;
  transition: transform 0.12s ease;
  &:active { transform: translateY(1px); }
  &:disabled { opacity: 0.6; cursor: default; }

  .spinner {
    width: 14px; height: 14px; margin-inline-start: 6px;
    border-radius: 50%;
    border: 2px solid var(--border);
    border-top-color: var(--text);
    display: none;
    animation: spin .8s linear infinite;
  }
  &[data-pending] .spinner { display: inline-block; }

  @keyframes spin { to { transform: rotate(360deg); } }
`;
